import { render, staticRenderFns } from "./my-account-setting-real-name-authentication.vue?vue&type=template&id=5db09f83&scoped=true&"
import script from "./my-account-setting-real-name-authentication.vue?vue&type=script&lang=js&"
export * from "./my-account-setting-real-name-authentication.vue?vue&type=script&lang=js&"
import style0 from "./my-account-setting-real-name-authentication.vue?vue&type=style&index=0&id=5db09f83&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db09f83",
  null
  
)

export default component.exports